<!--详情页面-->
<template>
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <!--拣货单打印样式（printtype=3，完全对齐原版 PickupPrint）-->
      <div v-if="printtype==3">
        <div v-if="remarkDisplay" style="border:1px solid #333;padding:14px;margin-bottom:12px;min-height:32px;line-height:2.0;font-size:12pt;">
          <span v-html="remarkDisplay"></span>
        </div>
        <table style="width:100%;border-collapse:collapse;font-size:12pt;">
          <tr>
            <td style="width:75px;padding:5px 8px;white-space:nowrap;font-size:10pt;" align="right"><b>订单日期：</b></td>
            <td style="padding:5px 8px;font-size:12pt;">{{pickupOrderDate}}</td>
          </tr>
          <tr>
            <td style="padding:5px 8px;white-space:nowrap;font-size:10pt;" align="right"><b>打印日期：</b></td>
            <td style="padding:5px 8px;font-size:12pt;">{{pickupPrintDate}}</td>
          </tr>
          <tr>
            <td style="padding:5px 8px;white-space:nowrap;font-size:10pt;" align="right"><b>订单号：</b></td>
            <td style="padding:5px 8px;font-size:10pt;">
              {{controlData.erpserial}}<br>
              <svg ref="barcodeSvg" style="height:32px;display:block;margin-top:4px;"></svg>
            </td>
          </tr>
          <tr>
            <td style="padding:5px 8px;white-space:nowrap;font-size:10pt;" align="right"><b>客户名称：</b></td>
            <td style="padding:5px 8px;font-weight:bold;font-size:12pt;">{{controlData.customername}}</td>
          </tr>
        </table>
        <!--镜片分组（按产品名称）-->
        <div v-if="lensGroups.length > 0" style="margin-top:15px;">
          <div v-for="(group, gIdx) in lensGroups" :key="'lg'+gIdx" style="margin-bottom:12px;">
            <div style="font-weight:bold;font-size:12pt;margin-bottom:6px;">{{group.name}}</div>
            <table style="width:100%;border-collapse:collapse;font-size:12pt;" class="query-table">
              <tr>
                <td style="text-align:center;border:1px solid #000;font-size:10pt;width:65px;">球镜</td>
                <td style="text-align:center;border:1px solid #000;font-size:10pt;width:65px;">柱镜</td>
                <td style="text-align:center;border:1px solid #000;font-size:10pt;width:65px;">ADD</td>
                <td style="text-align:center;border:1px solid #000;font-size:10pt;width:55px;">数量</td>
              </tr>
              <tr v-for="(item, iIdx) in group.items" :key="'l'+gIdx+'-'+iIdx">
                <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['球镜']!==undefined?item['球镜']:''}}</td>
                <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['柱镜']!==undefined?item['柱镜']:''}}</td>
                <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['ADD']!==undefined?item['ADD']:''}}</td>
                <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['数量']!==undefined?item['数量']:0}}</td>
              </tr>
              <tr>
                <td colspan="3" style="text-align:right;padding:6px 12px;border:1px solid #000;font-size:10pt;">小计：</td>
                <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:12pt;">{{formatInt(group.subtotal)}}</td>
              </tr>
            </table>
          </div>
        </div>
        <!--镜架分组（按品牌）-->
        <div v-if="frameGroups.length > 0" style="margin-top:15px;">
          <div v-for="(group, gIdx) in frameGroups" :key="'fg'+gIdx" style="margin-bottom:12px;">
            <div style="font-weight:bold;font-size:12pt;margin-bottom:6px;">{{group.name}}</div>
            <table style="width:100%;border-collapse:collapse;font-size:12pt;" class="query-table">
              <tr>
                <td style="text-align:center;border:1px solid #000;font-size:10pt;">型号</td>
                <td style="text-align:center;border:1px solid #000;font-size:10pt;">色号</td>
                <td style="text-align:center;border:1px solid #000;font-size:10pt;width:55px;">数量</td>
              </tr>
              <tr v-for="(item, iIdx) in group.items" :key="'f'+gIdx+'-'+iIdx">
                <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['型号']||''}}</td>
                <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['色号']||''}}</td>
                <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:13pt;">{{item['数量']||0}}</td>
              </tr>
              <tr>
                <td colspan="2" style="text-align:right;padding:6px 12px;border:1px solid #000;font-size:10pt;">小计：</td>
                <td style="text-align:center;font-weight:bold;padding:6px 8px;border:1px solid #000;font-size:12pt;">{{formatInt(group.subtotal)}}</td>
              </tr>
            </table>
          </div>
        </div>
        <div style="margin-top:15px;font-size:12pt;line-height:2.2;">
          <span style="font-weight:bold;font-size:12pt;">总数：{{formatInt(totalQuantity)}}</span>
          <span style="float:right;">打单人：{{userInfoModel.uname||''}}</span>
        </div>
      </div>
      <!--销售订单/取货单打印样式（printtype=1带价/2无价，对齐CstagreementEdit打印状态）-->
      <div v-else>
      <p :style="{textAlign:'center',fontSize:'18px',lineHeight:'40px'}">
        {{printbaibao?(pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle).replace('销售订单','取货单'):(pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle)}}
      </p>
      <div style="width: 640px;margin: 0 auto;text-align: right;"><img :src="imgpath"/></div>
      <table cellspacing="0" cellpadding="0" border="0"
             class="print-table"  :style="picture()">
        <tr class="noborder" style="height:26px">
          <td align="right" width="60">订单号：</td>
          <td style="width: 200px;max-width: 200px">{{controlData.erpserial}}</td>
          <td align="right" width="60">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.htqd||controlData.adddate}}</td>
          <td align="right" width="60">仓&nbsp;&nbsp;库：</td>
          <td width="120">{{controlData.cangkuname}}</td>
        </tr>
        <tr class="noborder" style="height:26px" v-if="!printbaibao">
          <td align="right">门&nbsp;&nbsp;店：</td>
          <td style="width: 200px;max-width: 200px"><span style="font-size: larger"><b>{{controlData.customername}}</b></span> {{controlData.customerserial}} {{controlData.shortname||''}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.deliveryaddress}}</td>
          <td align="right">联系人：</td>
          <td><span>{{(controlData.linkman||"")+" " +(controlData.linkmantel||"")}}</span>
          </td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right">运&nbsp;&nbsp;费：</td>
          <td>￥{{controlData.expressfee+" "+controlData.deliverymode}}</td>
          <td align="right" v-if="controlData.machinecstagreementDO&&controlData.machinecstagreementDO.unitguid">加工单：
          </td>
          <td v-if="controlData.machinecstagreementDO&&controlData.machinecstagreementDO.unitguid"
              style="font-weight:bold;cursor:pointer" >
            <span v-if="controlData.machinecstagreementDO">{{controlData.machinecstagreementDO.erpserial}} {{controlData.machinecstagreementDO.seedinfo}}</span>
            <span v-if="controlData.machinecstagreementDO&&(printDisplay||!isprint)">、{{controlData.machinecstagreementDO.htje-controlData.machinecstagreementDO.discount|0}}元</span>
           <span style="width: 240px;"><img :src="jiagongimgpath"/></span>
          </td>
        </tr>
        <tr>
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr >
                <td  style="text-align: center" v-for="item in column">{{item}}</td>
                <td v-if="showprice&&!printbaibao&&tableData.length>0" style="text-align: center">单价
                </td>
                <td v-if="showprice&&!printbaibao&&tableData.length>0" style="text-align: center">总价
                </td>
              </tr>
              <!--表头结束-->
              <tr v-for="item in tableData" style="cursor:pointer;" >
                <td :style="{textAlign:col=='产品名称'?'left':'center',minWidth:col=='产品名称'?'90px':''}"
                  v-for="col in column">
                  <div>{{getMapValue(item,col)}}</div><!--v-if="(!printBaiBao&&item=='产品名称')||item!='产品名称'"-->
                  <div v-if="col=='产品名称'" v-html="getGuanLGoods(item)"></div>
                </td>
                <td v-if="showprice&&!printbaibao&&tableData.length>0" style="text-align: center">
                  {{parseFloat(getMapValue(item,'单价')||0).toFixed(2)}}
                </td>
                <td v-if="showprice&&!printbaibao&&tableData.length>0" style="text-align: center">
                  {{parseFloat(getMapValue(item,'总价')||0).toFixed(2)}}
                </td>
              </tr>
              <!--表内容行结束-->
              <tr>
                <td v-for="(item,index) in column" style="text-align: center">
                  <span v-if="item=='产品名称'">合计</span>
                  <span v-if="item=='数量'">{{totalnumber}}</span>
                </td>
                <td
                  v-if="showprice&&!printbaibao&&(isprint||!isprint)&&tableData.length>0"
                  style="text-align: center"></td>
                <td
                  v-if="showprice&&!printbaibao&&(isprint||!isprint)&&tableData.length>0"
                  style="text-align: center">
                  {{totalmoney.toFixed(2)}}
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6" style="height: 10px"></td>
        </tr>
        <tr class="noborder">
          <td align="right">说&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px">
            <div v-html="getLiuYan(controlData.remark)">
            </div>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6" style="border:none">
            <!--<p>镜框类型：{{categoryname}}</p>-->
              <div style="float: left" v-for="(item,index) in parameter" v-if="item&&index.indexOf('优化')==-1">
              <span style="width:90px;display: inline-block;text-align: right">
              {{index+"："}}</span>
                <span style="width:70px;display: inline-block;text-align: left">{{item}}</span>
              </div>
          </td>
        </tr>
        <tr class="noborder" style="height:46px">
          <td colspan="2">&nbsp;&nbsp;&nbsp;开单人员：{{controlData.ssfzr||""}}</td>
          <td colspan="2"><div  style="float: left;width: 140px">出库人员：{{controlData.handleoveruname||""}}</div>
            <div v-if="!isshowyuandd&&!printbaibao" style="padding-right: 15px;float: right;width: 140px">支付方式：{{controlData.paymethod||""}}</div>
          </td>
          <td colspan="2">
            <span v-if="!isshowyuandd&&showprice&&!printbaibao" style="font-size: larger">总额：<b>{{subtotalmoney.toFixed(2)}}</b></span>
            <span v-else>&nbsp;</span>
          </td>
        </tr>
        <tr class="noborder" style="height:30px">
          <td colspan="6">&nbsp;</td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">GZ.NO：</td>
          <td>
            <span>{{form.logisticstracknum}}</span>
          </td>
          <td align="right">GY.NO：</td>
          <td colspan="3">
           {{controlData.tracknum}}
            <span v-if="isprint" style="padding-right: 20px;float: right;" v-html="printday"></span>
          </td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right">服务商：</td>
          <td v-if="isNoshow">{{pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle}}</td>
          <td v-else>{{controlData.applybydname}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.address}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.elinkman||"")+" "+(controlData.elinkmantel||"")}}</td>
        </tr>
      </table>
      </div>
    </div>
</template>


<script>
  import {
    printing,
    jxcstorelist,
    returnGoodsUpdate,
    ispsq,
    multipleShipments,
    pickingUp,
    checkprinting
  } from '@/api/set/csagreement';
  import {getRemark, getKHRemark} from '@/plugin/ordercommon'
  import {save} from '@/api/order/printlog';
  import JsBarcode from 'jsbarcode';

  export default {
    name: 'CstagreementPrint',
    data() {
      return {
        loading: false,
        pagetitle: '',
        printday: '',
        showscantable: true,
        imgpath: '',
        pageinit: {},
        jiagongimgpath: '',//加工单条形码
        userInfoModel: {},
        flage: true,
        formLabelWidth: '120px',
        subtotalmoney:0,
        isprint: false,
        showlookprice: false,
        seedcode: "",
        tableData: [],
        printData: [],//打印日志
        uname: '',//最新一条打印人员
        adddate: '',//最新一条打印时间
        unitguid: "",
        remark: "",
        remarkselection: '',
        cangkutuihuoremark: '',
        column: [],
        tuihuocolumn: [],
        controlData: {
          sycstagreementDO: {}, cstagreementDOList: []
        },
        parameterData: [],
        isshowyuandd: false,
        deliveryaddress: '',
        isycjorder: false,
        remarktype: '',
        isShowAdressAndCangkuUpdate: true,
        logisticsnumPre: '',
        logisticsnumEnd: '',
        form: {
          erpserial: "",
          deliverymode: 10,
          logisticsnum: '',
          customername: '',
          jxcformdetaillist: '',
          customerserial: '',
          independentserial: '',
          cangkucode: '',
          cangkuname: '',
          origionstatus: '',
          jxcformDetailDo: '',
          isdistribute: '',
          formtype: '',
          orderopinion: '',
          eliverydStatus: '',
          storegoodsbarcode: '',//库存商品唯一条码
          logisticstracknum: '',//跟踪单号
          invoicesource: 0,
          scancodes: [],//仓库发货扫唯一码
        },
        formLabelWidth: '120px',
        jxcstoreData: [],
        parameter: {},
        btn: '',
        status: '',
        totalnumber: 0,
        totalmoney: 0,
        handlelogData: [],//处理日期
        drawer: '',//开单人
        printDisplay: false,//打印是否显示价格
        roletype: '',//岗位类型
        onlyonecode: '',//唯一码
        isNoshow: false,//是否需要更换服务商
        goodsDetail: [],
      }
    },
    props: {
      printbaibao: {
        default: false
      },
      printtype: {//1=打印(带价) 2=打印(无价格) 3=拣货单
        default: 1
      },
    },
    computed: {
      //拣货单：镜片商品（含球镜字段）
      lensItems() {
        return this.goodsDetail.filter(item => item['球镜'] !== undefined)
      },
      //拣货单：镜架商品（无球镜字段）
      frameItems() {
        return this.goodsDetail.filter(item => item['球镜'] === undefined)
      },
      //拣货单：镜片按产品名称分组
      lensGroups() {
        const groups = {}
        for (const item of this.lensItems) {
          const name = item['产品名称'] || '未知'
          if (!groups[name]) {
            groups[name] = {name: name, items: [], subtotal: 0}
          }
          groups[name].items.push(item)
          groups[name].subtotal += (parseFloat(item['数量']) || 0)
        }
        return Object.values(groups)
      },
      //拣货单：镜架按品牌分组
      frameGroups() {
        const groups = {}
        for (const item of this.frameItems) {
          const productName = item['产品名称'] || '未知'
          let brand = productName
          if (item['型号']) {
            brand = brand.replace(item['型号'], '').trim()
          }
          if (item['色号']) {
            brand = brand.replace(item['色号'], '').trim()
          }
          brand = brand.replace(/[-–—/\\]/g, '').trim()
          if (!brand) brand = productName
          if (!groups[brand]) {
            groups[brand] = {name: brand, items: [], subtotal: 0}
          }
          groups[brand].items.push(item)
          groups[brand].subtotal += (parseFloat(item['数量']) || 0)
        }
        return Object.values(groups)
      },
      totalQuantity() {
        return this.goodsDetail.reduce((sum, item) => sum + (parseFloat(item['数量']) || 0), 0)
      },
      //拣货单备注（过滤人员和日期）
      remarkDisplay() {
        if (!this.controlData || !this.controlData.remark) return ''
        var html = getRemark(this.controlData.remark)
        return html.replace(/（[^）]*?）/g, '')
      },
      //拣货单订单日期
      pickupOrderDate() {
        return this.controlData ? (this.controlData.htqd || this.controlData.adddate || '') : ''
      },
      //拣货单打印日期（含秒，对齐原版PickupPrint）
      pickupPrintDate() {
        const now = new Date()
        const pad = n => String(n).padStart(2, '0')
        return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
      },
      //是否显示价格：无价格(printtype=2)强制隐藏，不受权限showlookprice影响
      showprice() {
        if (this.printtype == 2) return false;
        return this.printDisplay || this.showlookprice;
      }
    },
    methods: {
      picture(item) {
        if (this.controlData.isreturnorder&&this.controlData.isreturnorder==-1) {
          return {
            width:'100%',
            paddingRight: '0px',
            paddingLeft: '0px',
            background: 'url(/static/img/tuihuotip.png) no-repeat right center'
          }
        }
        return {
          width:'100%'
        }
      },
      getGuanLGoods(rows) {
        if (this.printbaibao) {
          var goods = this.getMapValue(rows, '关联产品');
          if (goods) {
            return '<div style="float: left;padding-left: 20px">' + goods + '</div>'
          }
        }
        return '';
      },
      getMapValue(ol, col) {
        var ret = ol[col];
        // for (let j = 0; j < ol.length; j++) {
        //   if (ol[j].hasOwnProperty(col))
        //     ret = ol[j][col];
        // }
        return ret;
      },
      setMapValue(ol, col, val) {
        var hasV = false;
        for (let j = 0; j < ol.length; j++) {
          if (ol[j].hasOwnProperty(col)) {
            hasV = true
            ol[j][col] = val;
          }
        }
        if (!hasV)
          ol.push({col: val});
      },
      formatTime() {
        var data = new Date();
        var year = data.getFullYear();
        var month = data.getMonth() + 1;
        var day = data.getDate();
        var hour = data.getHours();
        var minute = data.getMinutes();
        var second = data.getSeconds();
        return year + '-' + month + '-' + day + " " + hour + ":" + minute;
      },
      formatInt(val) {
        const num = parseInt(val);
        return isNaN(num) ? '0' : String(num);
      },
      //拣货单条形码（对齐原版PickupPrint：CODE128 svg）
      renderPickupBarcode() {
        this.$nextTick(() => {
          if (this.$refs.barcodeSvg && this.erpserial) {
            try {
              JsBarcode(this.$refs.barcodeSvg, this.erpserial, {
                format: 'CODE128',
                width: 2,
                height: 32,
                displayValue: false,
                margin: 5,
                background: '#ffffff'
              });
            } catch (e) {
              console.error('Barcode render error:', e);
            }
          }
        });
      },
      getTitle(showname) {
        let result = [];
        if (showname && showname != '') {
          if (showname.indexOf(';') != -1) {
            var obj = showname.split(';')
            for (let i in obj) {
              if (obj[i] && i == 0) {
                result = obj[i]
              } else if (obj[i]) {
                result += ';' + obj[i]
              }
            }
          } else {
            result = showname
          }
        } else {
          let temp = localStorage.getItem("hpapi_userInfoModel")
          if (temp) {
            result += JSON.parse(temp).tenantname || ""
          }
        }
        if (result.indexOf(';') != -1) {
          var obj = result.split(';')
          for (let i in obj) {
            if (obj[i]) {
              if (this.controlData.voucherdetailguid) {
                obj[i] += "铺货单"
              } else {
                obj[i] += "销售订单"
              }
              if (this.isshowyuandd) {
                obj[i] += "(退货单)"
              }
            }
          }
          result = obj.join(';')
        } else {
          if (this.controlData.voucherdetailguid) {
            result += "铺货单"
          } else {
            result += "销售订单"
          }
          if (this.isshowyuandd) {
            result += "(退货单)"
          }
        }
        return result
      },
      startprint() {
        this.printday = '（' + this.formatTime() + '打单）';
        this.isprint = true
      },
      tips() {
        if (this.uname) {
          return "(打印人：" + this.uname + ",时间：" + this.adddate + ")"
        } else {
          return "(未打印过)"
        }
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      getLiuYan(remark) {
        if (this.isprint) {
          return getKHRemark(remark);
        }
        return getRemark(remark);
      },
      initData(row) {
        this.pageinit.row = row
        this.initForm()

        this.status = row.status
        this.form.erpserial = row.erpserial
        this.imgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + row.erpserial

        if (row.customername) {
          this.form.customername = row.customername
        }
        if (row.cangkucode) {
          this.form.cangkucode = row.cangkucode
        }
        this.unitguid = row.unitguid
        printing({
          unitguid: row.unitguid,
          erpserial: this.form.erpserial,
          groupguid: '',
          seedcode: '',
          forprint:"1"
        }).then(response => {
          this.controlData = response.data.obj.detail;

          //加工单条形码
          if (this.controlData.machinecstagreementDO)
            this.jiagongimgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + this.controlData.machinecstagreementDO.erpserial
          //this.form.logisticstracknum = this.controlData.logisticstracknum

          if (this.controlData.returntype) {
            let remark = JSON.parse(this.controlData.remark)

            if (remark[1]) {
              this.remark = remark[1].msg
            }
            this.controlData.returntype = this.controlData.returntype + ''
          }
          //this.isshowyuandd = this.controlData.isreturnorder && this.controlData.isreturnorder == 1;

          this.form.invoicesource = response.data.obj.detail.invoicesource;
          this.printDisplay = (this.controlData.isshowprice.indexOf('4') != -1);
          //保存默认价格显示（打印类型切换时恢复用）
          this._defaultPrintDisplay = this.printDisplay;
          //printtype=2(无价格)不显示价格列
          if (this.printtype == 2) {
            this.printDisplay = false;
          }
          this.goodsDetail = response.data.obj.goodsDetail;
          this.tableData = response.data.obj.goodsDetail;
          this.flage=false
          this.pagetitle = this.getTitle(response.data.obj.detail.printdname);
          if (this.tableData.length > 0) {
            //取出表头
            let temparr = []
            let biaoji = 0
            var noShow=";unitguid;seedcode;packagesize;总价;关联产品;subseedcode;formproperty;单价;球镜;柱镜;产品名称;数量;R/L;是否坏件;轴位;发货数量;";

            for (let i in this.tableData) {
              this.totalnumber += (this.tableData[i]["数量"] || 0)
              this.totalmoney += (this.tableData[i]["总价"] || 0)
              for (let j in this.tableData[i]) {
                if (j == "R/L") {
                  biaoji = 1
                }
                if (j == "球镜") {
                  this.flage=true
                }
                if(noShow.indexOf(';'+j+';')==-1&&j.indexOf('优化')==-1&& !this.contains(j, temparr)){
                  temparr.push(j)
                }
              }
            }

            this.subtotalmoney=this.totalmoney+this.controlData.expressfee;
            if(this.controlData.machinecstagreementDO&&this.controlData.machinecstagreementDO.unitguid) {
              this.subtotalmoney += this.controlData.machinecstagreementDO.htje-this.controlData.machinecstagreementDO.discount|0;
            }

            //对表头排序
            if (biaoji == 1) {
              this.column.push("R/L")
            }
            this.column.push("产品名称")
            if (this.flage) {
              this.column.push("球镜")
              this.column.push("柱镜")
              this.column.push("轴位")
            }
            this.column = this.column.concat(temparr)
            this.column.push("数量")
          }

          this.parameter = response.data.obj.parameter
          this.startprint();
          this.renderPickupBarcode();//拣货单条形码
        });
      },
      //是否显示价格
      diaplayprice() {
        if (this.userInfoModel.myright.indexOf('财务') != -1 || this.userInfoModel.myright.indexOf('查看订单价格') != -1) {
          this.showlookprice = true;
        } else {
          this.showlookprice = false;
        }
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.showscantable = true
        this.handlelogData = []
        this.drawer = ''
        this.form.storegoodsbarcode = ''
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.totalmoney = 0
        this.totalnumber = 0
        this.isycjorder = false
        this.logisticsnumPre = '';
        this.logisticsnumEnd = localStorage.getItem("hpapi_sendexpressmobile");
        if (this.logisticsnumEnd == null)
          this.logisticsnumEnd = '';
        this.form.logisticsnum = ''
        this.form.isdistribute = ""
        this.form.cangkucode = ""
        this.form.cangkuname = ""
        this.form.erpserial = ""
        this.form.deliverymode = 10
        this.form.customername = ''
        this.form.customerserial = ''
        this.form.independentserial = ''
        this.form.origionstatus = ''
        this.form.jxcformDetailDo = ''
        this.form.formtype = ''
        this.form.orderopinion = ''
        this.form.eliverydStatus = ''
        this.uname = ''
        this.adddate = ''
        this.flage = true
        this.goodsbarcode = ''
        this.form.logisticstracknum = ''
        this.printDisplay = false
        this.remark = ""
        this.remarkselection = ""
        this.cangkutuihuoremark = ""
        this.form.scancodes = []
        this.showlookprice = false
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.diaplayprice()
    },
    watch: {
      //切换打印类型时：拣货单需重建条形码（initData时v-if未渲染barcodeSvg）；无价格需隐藏价格
      printtype(val) {
        if (val == 3) {
          this.$nextTick(() => {
            this.renderPickupBarcode();
          });
        } else if (val == 2) {
          this.printDisplay = false;//无价格
        } else if (val == 1) {
          //恢复默认：isshowprice含4则显示价格
          this.printDisplay = this.controlData && this.controlData.isshowprice && this.controlData.isshowprice.indexOf('4') != -1;
        }
      }
    },
    components: {},
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementPrint.vue